import { render, staticRenderFns } from "./ModalSelectPage.vue?vue&type=template&id=4267525e&scoped=true&"
import script from "./ModalSelectPage.vue?vue&type=script&lang=js&"
export * from "./ModalSelectPage.vue?vue&type=script&lang=js&"
import style0 from "./ModalSelectPage.vue?vue&type=style&index=0&id=4267525e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4267525e",
  null
  
)

export default component.exports